module.exports = __webpack_public_path__ + "media/pil_rund_vit.32e91923.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pil_rund_vit.svg
// module id = 489
// module chunks = 0